import React, {memo} from 'react';
import {Referral, ReferralDetail} from 'referral';


type Prop = {
    referral: Referral;
}

export const OfferReferralDetail = memo(function OfferReferralDetail({referral}: Prop) {
    return (
        <div className="shadow-xl
                  p-5 pr-0
                  flex flex-col
                  inset-0 border-0 rounded-tr-xl rounded-br-xl
                  outline-none focus:outline-none
                  bg-white
                  portal-provider-offer-referral-detail"
        >
            <div className="overflow-y-scroll scrollbar-always">
                <header className="modal-header
                flex items-start justify-between rounded-t"
                >
                    <h3 className='text-xl font-semibold'>
                        Referral
                    </h3>
                </header>

                <ReferralDetail referral={referral}/>
            </div>
        </div>
    );
});
